import { useOutletContext } from 'react-router-dom'
import InlineActionText from '../components/InlineActionText'
import type { SiteContext } from '../components/MainLayout'
import { PageIntro } from '../components/ui'
import { privacyConfig } from '../config/privacy'
import { usePageMeta } from '../hooks/usePageMeta'

export default function PrivacyPage() {
  const { language, copy } = useOutletContext<SiteContext>()
  const page = copy.privacy
  const updatedDate = new Intl.DateTimeFormat(language === 'el' ? 'el-GR' : 'en-GB', { dateStyle: 'long' })
    .format(new Date(`${privacyConfig.lastUpdated}T12:00:00Z`))
  usePageMeta({ language, title: page.title, description: page.intro })

  return (
    <>
      <PageIntro eyebrow={page.eyebrow} title={page.title} text={page.intro} />
      <section className="section privacy-section">
        <div className="shell privacy-policy">
          <p className="privacy-policy__updated"><span>{page.lastUpdatedLabel}</span><time dateTime={privacyConfig.lastUpdated}>{updatedDate}</time></p>

          <div className="privacy-list">
            {page.sections.map((section, index) => (
              <article key={section.title}>
                <span>0{index + 1}</span>
                <div>
                  <h2>{section.title}</h2>
                  {section.paragraphs.map((paragraph) => <p key={paragraph}><InlineActionText text={paragraph} language={language} /></p>)}
                  {section.items.length > 0 && <ul>{section.items.map((item) => <li key={item}><InlineActionText text={item} language={language} /></li>)}</ul>}
                  {section.links.length > 0 && (
                    <div className="privacy-policy__links">
                      {section.links.map((link) => (
                        <a key={link.href} href={link.href} target={link.href.startsWith('http') ? '_blank' : undefined} rel={link.href.startsWith('http') ? 'noreferrer' : undefined}>{link.label}</a>
                      ))}
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>

          <section className="privacy-storage" id="cookies" aria-labelledby="cookies-title">
            <p className="eyebrow">LOCAL STORAGE / COOKIES</p>
            <h2 id="cookies-title">{page.cookies.title}</h2>
            <p className="privacy-storage__intro">{page.cookies.intro}</p>
            <ul className="privacy-storage__list">
              {privacyConfig.storage.map((item) => (
                <li key={item.name}>
                  <div className="privacy-storage__header">
                    <code>{item.name}</code>
                    <span>{item.necessary ? page.cookies.necessary : page.cookies.optional}</span>
                  </div>
                  <dl>
                    <div><dt>{page.cookies.type}</dt><dd><code>{item.type}</code></dd></div>
                    <div><dt>{page.cookies.provider}</dt><dd>{item.provider[language]}</dd></div>
                    <div><dt>{page.cookies.category}</dt><dd>{item.necessary ? page.cookies.necessary : page.cookies.optional}</dd></div>
                    <div><dt>{page.cookies.purpose}</dt><dd>{item.purpose[language]}</dd></div>
                    <div><dt>{page.cookies.duration}</dt><dd>{item.duration[language]}</dd></div>
                    <div><dt>{page.cookies.necessary}</dt><dd>{item.necessary ? page.cookies.yes : page.cookies.no}</dd></div>
                  </dl>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </section>
    </>
  )
}
